module.exports = __webpack_public_path__ + "static/media/image-coming-soon-bferental.a6095c35.jpg";